import { authenticateRequest } from '@api/authenticateRequest';

import type { components, operations } from '@type/model';
import type { OmitGroupIdInHeader } from '@type/util';

type CreateFamilyEventHeaders = operations['EventController_registerEvent']['parameters']['header'];

type CreateFamilyEventData = components['schemas']['CreateEventDto'];

interface CreateFamilyEventProps {
  data: CreateFamilyEventData;
  headers?: OmitGroupIdInHeader<CreateFamilyEventHeaders>;
}

type CreateFamilyEventResponse = unknown;

export async function createFamilyEvent({
  data,
  headers,
}: CreateFamilyEventProps): Promise<CreateFamilyEventResponse | false> {
  const response = await authenticateRequest<CreateFamilyEventResponse>({
    method: 'post',
    url: `/api/v1/events`,
    data,
    headers,
  });

  console.log('getFamilyEvent', { response });
  return response;
}

export type { CreateFamilyEventResponse };
